import React, { Component, Fragment } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import {
  getConent,
  getContactConent,
  getCatTestimonial,
  getCompanyInformation,
} from "actions";
/*components*/
import _isLoading from "hoc/isLoading";
import HomeContact from "components/Home-contact";
import HomeTestimoninal from "components/Home-testimonials";
import { withTranslation } from "react-i18next";
import HomeReadyStart from "components/Home-ready-start";
import { Col, Row } from "reactstrap";
import Slider from "react-slick";
import FeaturesServiceCard from "./FeaturesServiceCard";
import OutsideClickHandler from "react-outside-click-handler";
import { v4 as uuidv4 } from "uuid"; // Import UUID library

class Features extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedListItem: {
        text: this.props.t("featuresLanding.services.0.rowHeading"),
        secId: "features-staff-management",
      },
      showDropdown: false,
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.getConent({ id: 3 });
    this.props.getContactConent({ id: 5 });
    this.props.getCatTestimonial({ id: 8 });
    this.props.getCompanyInformation();
  }
  render() {
    const { testimonialList, t } = this.props;
    const bannerSettings = {
      dots: false,
      infinite: true,
      speed: 600,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      fade: true,
      autoplaySpeed: 3500,
      cssEase: "linear",
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            dots: true,
          },
        },
      ],
    };
    const settings = {
      dots: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    const toggleDropdown = () => {
      this.setState({
        showDropdown: !this.state.showDropdown,
      });
    };

    const selectDropdownItem = (item) => {
      this.setState({
        selectedListItem: item,
        showDropdown: false,
      });
      if (item.secId) {
        const element = document.getElementById(item.secId);
        if (element) {
          const headerOffset = 70;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            behavior: "smooth",
            top: offsetPosition,
          });
        }
      }
    };
    const dropdownData = [
      {
        text: t("featuresLanding.services.0.rowHeading"),
        secId: "staff-management",
      },
      {
        text: t("featuresLanding.services.1.rowHeading"),
        secId: "job-personnel",
        rowReverse: true,
      },
      {
        text: t("featuresLanding.services.2.rowHeading"),
        secId: "virtual-hr-manager",
      },
      {
        text: t("featuresLanding.services.3.rowHeading"),
        secId: "online-patient-services",
        sliderInnerList: true,
        rowReverse: true,
      },
      {
        text: t("featuresLanding.services.4.rowHeading"),
        secId: "personnel-scheduler",
      },
      {
        text: t("featuresLanding.services.5.rowHeading"),
        secId: "leave-timeoff-tracking",
      },
      {
        text: t("featuresLanding.services.6.rowHeading"),
        secId: "timesheet-management",
      },
      {
        text: t("featuresLanding.services.7.rowHeading"),
        secId: "online-legal-forms",
        rowReverse: true,
      },
      {
        text: t("featuresLanding.services.8.rowHeading"),
        secId: "peer-review-and-patient-referral",
        trialBtn: true,
      },
      {
        text: t("featuresLanding.services.9.rowHeading"),
        secId: "tele-health",
        trialBtn: false,
        rowReverse: true,
      },
      {
        text: t("featuresLanding.services.10.rowHeading"),
        secId: "business-dashboards",
        trialBtn: false,
      },
      {
        text: t("featuresLanding.services.11.rowHeading"),
        secId: "inventory-supply-management",
        trialBtn: false,
        rowReverse: true,
        notesText: false,
      },
      {
        text: t("featuresLanding.services.12.rowHeading"),
        secId: "order-delivery-management",
        trialBtn: false,
      },
    ];
    return (
      <Fragment>
        <div className="landing-page-block">
          <div className="banner-new-section features-banner banner-block">
            <Slider {...bannerSettings}>
              <div className="slider-single">
                <img
                  className="d-none img-cover d-md-block"
                  src={require("assets/images/landing-pages/features-web-banner.jpg")}
                  alt="img"
                />
                <img
                  className="d-block img-cover img-right d-md-none"
                  src={require("assets/images/landing-pages/features-mobile-banner.jpg")}
                  alt="img"
                />
              </div>
            </Slider>
            <div className="banner-caption">
              <div className="text-width">
                <div className="banner-label">{t("AppsFeatures")}</div>
                <h2 className="font-46">
                  {t("featuresLanding.featuresBannerHeading")}
                </h2>
                <p>{t("featuresLanding.featuresBannerDesc")}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="app-page">
          <div className="overview-green-bg-section features-green-sec">
            <div className="container">
              <div className="overview-slider">
                <Slider {...settings}>
                  <div className="card-block">
                    <h4 className="heading-title">
                      {t("featuresSlider.sliderText1")}
                    </h4>
                    <img
                      className="img-1"
                      src={require("assets/images/landing-pages/features-slider-img1.png")}
                      alt="img"
                    />
                  </div>
                  <div className="card-block">
                    <h4 className="heading-title">
                      {t("featuresSlider.sliderText2")}
                    </h4>
                    <img
                      className="img-2"
                      src={require("assets/images/landing-pages/features-slider-img2.png")}
                      alt="img"
                    />
                  </div>
                  <div className="card-block">
                    <h4 className="heading-title">
                      {t("featuresSlider.sliderText3")}
                    </h4>
                    <img
                      className="img-3"
                      src={require("assets/images/landing-pages/features-slider-img3.png")}
                      alt="img"
                    />
                  </div>
                </Slider>
              </div>
            </div>
          </div>
          {dropdownData.map((values, index) => {
            const series1 = `featuresLanding.services.${index}.slider.0.title`;
            const series2 = `featuresLanding.services.${index}.slider.0.text1`;
            const series3 = `featuresLanding.services.${index}.slider.0.text2`;
            const series4 = `featuresLanding.services.${index}.slider.0.text3`;
            const series5 = `featuresLanding.services.${index}.slider.0.text4`;
            const series = `featuresLanding.services.${index}.slider.1.title`;
            const series6 = `featuresLanding.services.${index}.slider.1.text1`;
            const series7 = `featuresLanding.services.${index}.slider.1.text2`;
            const series8 = `featuresLanding.services.${index}.slider.1.text3`;
            const series9 = `featuresLanding.services.${index}.slider.2.title`;
            const series10 = `featuresLanding.services.${index}.slider.2.text1`;
            const series11 = `featuresLanding.services.${index}.slider.2.text2`;
            const series12 = `featuresLanding.services.${index}.slider.2.text3`;
            return (
              <FeaturesServiceCard
                key={values.secId}
                secId={values.secId}
                notesText={values.notesText}
                rowReverse={values.rowReverse}
                sliderInnerList={values.sliderInnerList}
                trialBtn={values.trialBtn}
                SignupClick={this.props.SignupClick}
                rowHeading={values.text}
                rowTagline={t(`featuresLanding.services.${index}.rowTagline`)}
                rowDesc={t(`featuresLanding.services.${index}.rowDesc`)}
                rowImage={require(`assets/images/landing-pages/features-service${
                  index + 1
                }.png`)}
                mobileImage={require(`assets/images/landing-pages/features-mobile-service${
                  index + 1
                }.png`)}
                ctaText={t(`featuresLanding.services.${index}.ctaText`)}
                sliderCard1Title={t(series1) === series1 ? null : t(series1)}
                sliderCard1Text1={t(series2) === series2 ? null : t(series2)}
                sliderCard1Text2={t(series3) === series3 ? null : t(series3)}
                sliderCard1Text3={t(series4) === series4 ? null : t(series4)}
                sliderCard1Text4={t(series5) === series5 ? null : t(series5)}
                sliderCard2Title={t(series) === series ? null : t(series)}
                sliderCard2Text1={t(series6) === series6 ? null : t(series6)}
                sliderCard2Text2={t(series7) === series7 ? null : t(series7)}
                sliderCard2Text3={t(series8) === series8 ? null : t(series8)}
                sliderCard3Title={t(series9) === series9 ? null : t(series9)}
                sliderCard3Text1={t(series10) === series10 ? null : t(series10)}
                sliderCard3Text2={t(series11) === series11 ? null : t(series11)}
                sliderCard3Text3={t(series12) === series12 ? null : t(series12)}
              />
            );
          })}

          <div className="hexagon-section">
            <div className="container">
              <Row className="align-items-center">
                <Col lg="7">
                  <div className="text-col">
                    <h2> {t("userPages.readyToTransformYourBusiness")}</h2>
                    <p> {t("featuresLanding.hexagonDesc1")}</p>

                    <p>
                      {" "}
                      <u
                        className="cursor-pointer"
                        onClick={this.props.SignupClick}
                      >
                        {t("userPages.dentistHexaDesc1")}
                      </u>{" "}
                      {t("featuresLanding.hexagonDesc2")}
                    </p>
                  </div>
                </Col>
                <Col lg="5">
                  <div className="image-col">
                    <img
                      src={
                        require("assets/images/landing-pages/hexagon.svg")
                          .default
                      }
                      alt="icon"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <HomeReadyStart />
          <HomeContact companyInformation={this.props.companyInformation} />
          {testimonialList && testimonialList.length > 0 && (
            <HomeTestimoninal
              title={t("userPages.testimonialTitle")}
              data={testimonialList}
            />
          )}
        </div>
        <section className="features-fixed-sec">
          <div className="container">
            <div className="content-box">
              <div className="select-content">
                {t("featuresLanding.fixedMenuText")}
              </div>
              <div className="dropdown-wrapper">
                <OutsideClickHandler
                  onOutsideClick={() => {
                    this.setState({
                      showDropdown: false,
                    });
                  }}
                >
                  <div className="dropdown-content" onClick={toggleDropdown}>
                    {this.state.selectedListItem.text}
                    <img
                      src={require("assets/images/down-arrow.svg").default}
                      alt="img"
                    />
                  </div>
                  {this.state.showDropdown && (
                    <ul className="dropdown-list">
                      {dropdownData.map((item) => {
                        const { text, secId } = item;
                        const isActive =
                          secId === this.state.selectedListItem.secId;
                        return (
                          <li
                            key={uuidv4()}
                            onClick={() => selectDropdownItem(item)}
                            className={`${isActive ? "active" : ""}`}
                          >
                            {text}
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </OutsideClickHandler>
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  userProfile: { profile },
  pageContent: {
    isLoading,
    pageContent,
    contactContent,
    testimonialList,
    companyInformation,
  },
  errors: { isError },
}) => ({
  isLoading,
  isError,
  profile,
  pageContent,
  contactContent,
  testimonialList,
  companyInformation,
});

export default connect(mapStateToProps, {
  getConent,
  getContactConent,
  getCatTestimonial,
  getCompanyInformation,
})(_isLoading(withTranslation()(Features)));
